import React from "react";
import "./CEOMessage.css";
import ceoImg from "../Assets/About/CEO.jpg"; // Add CEO image

export default function CEOMessage() {
  return (
    <section className="ceo-message">
      <div className="ceo-message__inner">
        {/* Left: CEO Image */}
        <div className="ceo-message__image">
          <img src={ceoImg} alt="CEO - AdsOn Digital" />
        </div>

        {/* Right: Message Content */}
        <div className="ceo-message__content">
          <h2 className="ceo-message__title">Message from Our CEO</h2>
          <p className="ceo-message__text">
            "At <strong>AdsOn Digital</strong>, our mission is to empower brands
            to reach their highest potential through innovative strategies and
            cutting-edge technology. We believe in delivering results that go
            beyond numbers – building trust, creativity, and long-term growth
            for our partners."
          </p>
          <p className="ceo-message__quote">
            <em>
              "Success in digital marketing is not about being everywhere, but
              being where it matters most."
            </em>
          </p>
          <h4 className="ceo-message__name">Mr. Ali Akbar Mirza</h4>
          <span className="ceo-message__designation">CEO & Founder, AdsOn Digital</span>

          {/* Contact Info */}
          <div className="ceo-message__contact">
            <p><strong>Phone:</strong> <a href="tel:+971524230667">+971 52 423 0667</a></p>
            <p><strong>Email:</strong> <a href="mailto:info@adsondigitals.com">info@adsondigitals.com</a></p>
          </div>
        </div>
      </div>
    </section>
  );
}
